"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.updateNavFor = updateNavFor;
exports.updateArrowClasses = updateArrowClasses;
exports.updateArrows = updateArrows;
exports.updateDots = updateDots;
function updateNavFor() {
    if (this.config.options.navFor) {
        var offset = this.config.options.navForOffset || 0;
        this.config.options.navFor.changeSlide(this.currentSlide + offset);
    }
}

function updateArrowClasses() {
    if (!this.config.options.arrows || this.config.options.infinite) {
        return;
    }

    if (this.currentSlide === 0) {
        this.elements.prevArrow.classList.add(this.config.classes.disabledArrow);
    } else {
        this.elements.prevArrow.classList.remove(this.config.classes.disabledArrow);
    }

    if (this.currentSlide === this.maxSlideScroll - 1) {
        this.elements.nextArrow.classList.add(this.config.classes.disabledArrow);
    } else {
        this.elements.nextArrow.classList.remove(this.config.classes.disabledArrow);
    }
}

function updateArrows() {
    if (!this.config.options.arrows || this.config.options.infinite) {
        return;
    }

    if (this.currentSlide === 0) {
        this.elements.prevArrow.disabled = true;
    } else {
        this.elements.prevArrow.disabled = false;
    }

    if (this.currentSlide === this.maxSlideScroll - this.config.options.slidesToShow) {
        this.elements.nextArrow.disabled = true;
    } else {
        this.elements.nextArrow.disabled = false;
    }
}

function updateDots() {
    var _this = this;

    if (!this.config.options.dots) {
        return;
    }

    var currentSlide = this.currentSlide;
    if (this.config.options.infinite) {
        if (currentSlide === this.slideCount) {
            currentSlide = 0;
        }
        if (currentSlide === -this.config.options.slidesToShow) {
            currentSlide = this.slideCount - 1;
        }
    }

    this.elements.dots.map(function (el, index) {
        if (index === currentSlide) {
            el.classList.add(_this.config.classes.activeDot);
        } else {
            el.classList.remove(_this.config.classes.activeDot);
        }
    });
}


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/src/slider/updates.js
// module id = ./resources/assets/js/src/slider/updates.js
// module chunks = 0